export { default } from './faq-block';
